import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ApplicationResponse } from "@src/common/domain/common.model";
import api from "@src/common/services/api.service";
import AppConstants from "@src/utils/app.constants";
import convertToForm from "@src/utils/payload-to-form-converter";
import { MileStoneStore } from "../domain/milestone-model";
export const updateMilestones = createAsyncThunk<void, any>("milestone/updateMilestone",
 async (payload: any) => {
    const response = await api.put<ApplicationResponse<any>>(`${AppConstants.api}/milestone`, payload)
})
export const fetchMilestonesList = createAsyncThunk<
  any[],
  { projectId: string; type: string }
>("milestone/fetchMilestones", async ({ projectId, type }) => {
  const url = `${AppConstants.api}/milestone`;

  const response = await api.get<ApplicationResponse<any[]>>(url, {
    params: {
      projectId,
      projectType: type.toUpperCase(),
    },
  });
  return response.data.data || [];
});

const MileStoneSlice = createSlice({
  name: "mileStone",
  initialState: {
    minimal: { status: "loading", error: null, data: [] },
  } as MileStoneStore,
  reducers: {
    resetMileStones: (state) => {
      state.minimal = {
        status: "loading",
        error: null,
        data: [],
      };
    },
      updateMilestone: (state, action: PayloadAction<any>) => {
      state.minimal.data = state.minimal.data.map(milestone => 
        milestone.id === action.payload.id ? action.payload : milestone
      );
    },
  
    addMilestone: (state, action) => {
      state.minimal.data.push(action.payload);
    },
    removeMileStone: (state, action) => {
      state.minimal.data = state.minimal.data.filter(
        (mileStone: any) => mileStone.id !== action.payload
      );
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMilestonesList.pending, (state, action) => {
        state.minimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(fetchMilestonesList.fulfilled, (state, action) => {
        state.minimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchMilestonesList.rejected, (state, action) => {
        state.minimal = {
          status: "failed",
          data: [],
          error: action.error,
        };
      });
  },
});
export const { removeMileStone, addMilestone,updateMilestone, resetMileStones } =
  MileStoneSlice.actions;

export default MileStoneSlice.reducer;
